
angular.module('bmsApp.directives').controller('EmailSendModalFormCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$modalInstance',
	'$ngBootbox',
	'DocumentSvc',
	'EmailAccountsDataSvc',
	'EmailSvc',
	'email',
	'customer',
	'$log',
	function (
		$scope,
		$q,
		$timeout,
		$modalInstance,
		$ngBootbox,
		DocumentSvc,
		EmailAccountsDataSvc,
		EmailSvc,
		email,
		customer,
		$log) {

		$scope.email = {
			attachments: [],
			adhocAttachments:[], // those uploaded on the fly
			use_template: 1
		};
		angular.extend($scope.email, email);

		$scope.dropzoneErrors = [];
		$scope.dropzone = {
			config: {
				url: 'api/email/upload',
				parallelUploads: 3,
				maxFileSize: 5,
				acceptedFiles: '.csv, .xls, .xlsx, .jpg, .jpeg, .png, .doc, .docx, .pdf',
				eventHandlers: {
					drop: function (event) {
						$scope.dropzoneErrors = [];
					},
					success: function (file, response) {
						$scope.email.adhocAttachments.push({type: 'email', filename: response.filename});
					},
					removedfile: function (file) {
						FileSvc.delete(file.serverFilepath)
							.then(function (response) {
								$log.log('Dropzone file removed');
							}, function (error) {
								$log.error('Failed to remove dropzone file: ' + error);
							});
					},
					error: function (file, errorMessage) {
						$scope.dropzoneErrors.push(errorMessage);
					}
				}
			}
		};

		// Outgoing email account
		$scope.outgoingEmailAccountsOptions = [];
		EmailAccountsDataSvc.outgoingOptions().then((response) => {
			$scope.outgoingEmailAccountsOptions = response.data.outgoingEmailAccountsOptions;
			$scope.defaultOutgoingEmailAccount = response.data.defaultOutgoingEmailAccount;
			if (!!customer && !!customer.license && customer.license.default_email_account) {
				$scope.email.outgoing_email_account = customer.license.default_email_account.id;
			} else {
				$scope.email.outgoing_email_account = response.data.defaultOutgoingEmailAccount.id;
			}
		});

		var documentOptionPromise;
		$scope.documentOptions = [];
		if (angular.isObject(customer) && $scope.email.object_type == 'App\\Models\\Crm\\Customer') {
			documentOptionPromise = DocumentSvc.optionsByCustomer(customer.id, {});
		}
		else if (angular.isObject(customer) && $scope.email.object_type == 'App\\Models\\Crm\\Enquiry') {
			documentOptionPromise = DocumentSvc.optionsByEnquiry(customer.id, {});
		}
		else if ($scope.email.object_type == 'App\\Models\\Trugreen\\Job') {
			documentOptionPromise = DocumentSvc.optionsByTgJob($scope.email.object_id, {});
		}
		else if ($scope.email.object_type == 'App\\Models\\Sm\\Job') {
			documentOptionPromise = DocumentSvc.optionsBySmJob($scope.email.object_id, {});
		}
		else if ($scope.email.object_type == 'App\\Models\\Merrymaids\\Job') {
			documentOptionPromise = DocumentSvc.optionsByMmJob($scope.email.object_id, {});
		}
		else {
			documentOptionPromise = DocumentSvc.options({});
		}
		$scope.loading = true;
		$scope.processing = false;
		documentOptionPromise.then(function (response) {
			$timeout(function () {
				$scope.$apply(function () {
					$scope.documentOptions = response.data.options;
					$scope.loading = false;
				});
			}, 0);
		});

		$scope.addAttachment = function () {
			$scope.email.attachments.push({});
		};

		$scope.removeAttachment = function (attachment) {
			var index = $scope.email.attachments.indexOf(attachment);
			$scope.email.attachments.splice(index, 1);
		};

		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit($scope.email);
			},
			errorPlacement: function (error) {
				error.appendTo('#email-errors');
			},
			errorContainer: '#email-errors'
		};

		$scope.submit = function (email) {
			$scope.processing = true;
			var modalResult = {};
			EmailSvc.send(email)
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.email = email;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error[0];
					$modalInstance.close(modalResult);
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};
		
	}]);
